import React from 'react';
import { pdf } from '@react-pdf/renderer';
import BpInvoicePdfDocument from './BpInvoicePdfDocument';
import BpStatementPdfDocument from './BpStatementPdfDocument';
import { BpInvoicePdfInput, BpStatementPdfInput } from './invoicePdfTypes';

async function pdfToFile(element: React.ReactElement, filename: string): Promise<File> {
    const instance = pdf();
    instance.updateContainer(element);
    const blob = await instance.toBlob();
    return new File([blob], filename, { type: 'application/pdf', lastModified: Date.now() });
}

export async function getBpInvoicePdfFile(input: BpInvoicePdfInput): Promise<File> {
    const name = `${input.invoiceNumber}.pdf`;
    return pdfToFile(<BpInvoicePdfDocument {...input} />, name);
}

export async function getBpStatementPdfFile(input: BpStatementPdfInput): Promise<File> {
    const name = `Statement-${input.accountNumber}.pdf`;
    return pdfToFile(<BpStatementPdfDocument {...input} />, name);
}
